export default __webpack_public_path__ + "3ed5ccbaafbdf37b7d848f43cc556dc6.png";